import React, { Component } from 'react';
import { AlertModel, AlertType } from './app-alert.model';
import { AlertCancelIcon } from '../../../icon';

interface IProps extends AlertModel {
    OnClose: () => void;
    ShowAlert: boolean;
    TextProps: () => JSX.Element;
}

interface IState {

}

class AppAlertComponent extends Component<IProps, IState> {

    GetColorVariable = (): string => {
        switch (this.props.Type) {
            case AlertType.SUCCESS:
                return `primary-${AlertType.SUCCESS.toString().toLowerCase()}`;

            case AlertType.WARNING:
                return `primary-${AlertType.WARNING.toString().toLowerCase()}`;

            case AlertType.DANGER:
                return `primary-${AlertType.DANGER.toString().toLowerCase()}`;

            case AlertType.INFO:
                return `primary-${AlertType.INFO.toString().toLowerCase()}`;

            case AlertType.DISABLED:
                return `primary-${AlertType.DISABLED.toString().toLowerCase()}`;

            default: return "";
        }
    }
    render() {
        return (
            <section className={`bg-alert-${this.GetColorVariable()} w-p-100 alert-message p-relative ${this.props.ShowAlert ? 'open' : 'close'}`}>
               {this.props.ShowAlert && <div className={`d-flex color-secondary h5-regular p-2`}>
                    <span className={"align-center m-auto"}>{this.props.TextProps()}</span>
                    {this.props.ShowAlert &&
                        <AlertCancelIcon className={"mr-2 w-3 c-pointer"} onClick={this.props.OnClose} />}
                </div>}
            </section>
        )
    }
}
export default AppAlertComponent;